<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#173EA3"
      :is-full-page="fullPage"
    ></loading>
    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
        <h5>Add Vehicle</h5>
  
        <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-3" style="margin-top: 1%">
            <span class="p-float-label">
              <Dropdown
                id="status"
                v-model="status_dropdownItem"
                :options="status_dropdownItems"
                optionLabel="name"
                :class="{ 'p-invalid': submitted && !status_dropdownItem }"
              >
              </Dropdown>
              <label for="status">Status</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 1%">
            <span class="p-float-label">
              <Dropdown
                id="User"
                filter
                v-model="dropdownItem"
                :options="dropdownItems"
                optionLabel="name"
                :class="{ 'p-invalid': submitted && !dropdownItem }"
              >
              </Dropdown>
              <label for="vehicle_type">Vehicle Type</label>
            </span>
          </div>
          
          <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="registration_number" type="text" v-model="registration_number"
                                :class="{ 'p-invalid': submitted && !registration_number }" />
                            <label for="registration_number">Registration No.</label>
                        </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <span class="p-float-label">

                            <InputText type="text" id="mobile_number_rc" v-model="mobile_number_rc"
                                onkeypress="return event.charCode>=48 && event.charCode<=57"
                                maxlength="10"
                                :class="{ 'p-invalid': submitted && !mobile_number_rc }" />
                            <label for="mobile_number_rc">Mobile No Connected to Rc</label>
                        </span>
                    </div>
          <div class="field col-12 md:col-3" style="margin-top: 1%">
            <span class="p-float-label">
              <Dropdown
                id="User"
                filter
                v-model="district_dropdownItem"
                :options="district_dropdownItems"
                optionLabel="name"
                @change="get_block_master"
                :class="{ 'p-invalid': submitted && !district_dropdownItem }"
              >
              </Dropdown>
              <label for="vehicle_type">District</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 1%">
            <span class="p-float-label">
              <Dropdown
                id="User"
                filter
                v-model="block_dropdownItem"
                :options="block_dropdownItems"
                :loading="set_loading"
                optionLabel="name"
                @change="getPanchayatData"
                :class="{ 'p-invalid': submitted && !block_dropdownItem }"
              >
              </Dropdown>
              <label for="vehicle_type">Block</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 1%">
            <span class="p-float-label">
              <Dropdown
                id="var "
                filter
                v-model="panchayat_dropdownItem"
                :options="panchayat_dropdownItems"
                optionLabel="name"
                @change="get_village_master()"
              >
              </Dropdown>
              <label for="panchayat">Panchayat</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 1%">
            <span class="p-float-label">
              <Dropdown
                id="User"
                filter
                v-model="village_dropdownItem"
                :options="village_dropdownItems"
                optionLabel="name"
                @filter="get_village_master"
                :class="{ 'p-invalid': submitted && !village_dropdownItem }"
              >
              </Dropdown>
              <label for="vehicle_type">Village</label>
            </span>
          </div>
        </div>
        <Divider />
        <p align="right">
            <Button label="Save" @click="save_vehicle()" v-tooltip.bottom="'Save'" />&nbsp;
            <Button label="Reset" @click="refresh()" v-tooltip.bottom="'Save'" />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ProductService from "../service/ProductService";
import BreadcrumbService from "../service/BreadcrumbService";
import apis from "@/apis";
import axios from "axios";
export default {
  name: "SbmUiVehicleAddTrack",

  data() {
    return {
      productService: null,
      BreadcrumbService: null,
      breadcrumbHome: {},
      breadcrumbItems: [],
      isLoadingModel: false,
      dropdownItems: [],
      dropdownItem: null,
      status_dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      status_dropdownItem: { name: "Active", value: "Active" },
      district_dropdownItems: [],
      district_dropdownItem: null,
      block_dropdownItems: [],
      block_dropdownItem: null,
      village_dropdownItems: [],
      village_dropdownItem: null,
      panchayat_dropdownItems: [],
      panchayat_dropdownItem: null,
      registration_number:"",
      mobile_number_rc:"",
      id:"",
    };
  },

  async mounted() {
    this.productService = new ProductService();
    this.BreadcrumbService = new BreadcrumbService();

    let link = [
      { label: "Vehicle", to: "/vehiclemaster" },
      { label: "Vehicle Add", to: "/vehicle_add" },
    ];
    let Breadcrum_data = this.BreadcrumbService.getBreadcrummultiple(link);
    this.breadcrumbHome = Breadcrum_data.home;
    this.breadcrumbItems = Breadcrum_data.items;

    await this.get_vehicle_type_master();
    await this.get_district_master();
  },

  methods: {
    async get_vehicle_type_master() {
      const client_group_ids = localStorage.getItem("client_group_ids")
        ? JSON.parse(localStorage.getItem("client_group_ids"))
        : [];

      this.loading = true;
      var data = {
        client_id: localStorage.getItem("client_id"),
        client_group_ids: client_group_ids,
      };
      var promise = apis.vehicle_type_master(data);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x].name,
            });
          }
          this.dropdownItems = temp_data;
        }
      });
    },
    async get_district_master() {
      const client_group_ids = localStorage.getItem("client_group_ids")
        ? JSON.parse(localStorage.getItem("client_group_ids"))
        : [];
      this.loading = true;
      var data = {
        client_id: localStorage.getItem("client_id"),
        client_group_ids: client_group_ids,
        count: false,
      };
      var promise = apis.getStateData(data);
      promise.then((response) => {
        this.loading = false;

        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x].code,
            });
          }
          this.district_dropdownItems = temp_data;
        }
      });
    },
    async get_block_master() {
      var district_code = [];
      if (this.district_dropdownItem) {
        district_code.push(this.district_dropdownItem.value);
      }
      this.set_loading = true;
      var data = {
        count: false,
        district_code: district_code,
      };
      var promise = apis.getBlockData(data);
      promise.then((response) => {
        this.set_loading = false;

        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x].code,
            });
          }
          this.block_dropdownItems = temp_data;
        }
      });
    },
    async getPanchayatData() {
      this.panchayat_dropdownItem = null;
      this.panchayat_dropdownItems = [];
      var district_code = [];
      var block_code = [];
      this.loading = true;

      if (this.district_dropdownItem) {
        district_code.push(this.district_dropdownItem.value);
      }
      if (this.block_dropdownItem) {
        block_code.push(this.block_dropdownItem.value);
      }
      var data = {
        district_code: district_code,
        block_code: block_code,
        count: false,
      };
      var promise = apis.getPanchayatData(data);
      var temp_data = [];
      this.loading = false;

      promise.then((response) => {
        if (response.data.data) {
          for (var k = 0; k < response.data.data.length; k++) {
            temp_data.push({
              name: response.data.data[k]["Local Body Name"],
              value: response.data.data[k]["Local Body Code"],
            });
          }
          this.panchayat_dropdownItem = null;
          this.panchayat_dropdownItems = temp_data;
        }
      });
    },
    async get_village_master() {
      this.village_dropdownItem = null;
      this.village_dropdownItems = [];
      var district_code = [];
      var block_code = [];
      var panchayat_code = [];
      this.loading = true;

      if (this.district_dropdownItem) {
        district_code.push(this.district_dropdownItem.value);
      }
      if (this.block_dropdownItem) {
        block_code.push(this.block_dropdownItem.value);
      }
      if (this.panchayat_dropdownItem) {
        panchayat_code.push(this.panchayat_dropdownItem.value);
      }
      var data = {
        count: false,
        page_no: 1,
        limit: 10,
        district_code: district_code,
        block_code: block_code,
        panchayat_code: panchayat_code,
      };
      var promise = apis.getVillageData(data);
      promise.then((response) => {
        this.loading = false;

        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].village_name,
              value: response.data.data[x].village_code,
            });
          }
          this.village_dropdownItems = temp_data;
        }
      });
    },
    async save_vehicle()
    {
        if (this.registration_number=='') 
        {
                this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Registration Number",
            life: 3000
            });
            return false;
        }
        var type            = "";
        var status          = "";
        var district_id     = "";
        var district_name   = "";
        var block_id        = "";
        var block_name      = "";
        var village_id      = "";
        var village_name    = "";
        var panchayat_id    = "";
        var panchayat_name  = "";

        var district_dropdownItem = this.district_dropdownItem;
        if (district_dropdownItem && district_dropdownItem.value != null && district_dropdownItem.name != null) 
        {
                district_id = district_dropdownItem.value;
                district_name = district_dropdownItem.name;
        }

        var block_dropdownItem = this.block_dropdownItem;
        if (block_dropdownItem && block_dropdownItem.value != null && block_dropdownItem.name != null) 
        {
                block_id = block_dropdownItem.value;
                block_name = block_dropdownItem.name;
        }

        var panchayat_dropdownItem = this.panchayat_dropdownItem;
        if (panchayat_dropdownItem && panchayat_dropdownItem.value != null && panchayat_dropdownItem.name != null) 
        {
            panchayat_id = panchayat_dropdownItem.value;
            panchayat_name = panchayat_dropdownItem.name;
        }

        var village_dropdownItem = this.village_dropdownItem;
        if (village_dropdownItem && village_dropdownItem.value != null && village_dropdownItem.name != null) 
        {
            village_id = village_dropdownItem.value;
            village_name = village_dropdownItem.name;
        }
        
        var status_dropdownItem = this.status_dropdownItem;
        if (status_dropdownItem && status_dropdownItem.value != null && status_dropdownItem.name != null) 
        {
            status = status_dropdownItem.value;
       
        }

        var dropdownItem = this.dropdownItem;
        if (dropdownItem && dropdownItem.value != null && dropdownItem.name != null) 
        {
            type = dropdownItem.value;
       
        }       

        var details={
                "client_id"             :localStorage.getItem("client_id")?localStorage.getItem("client_id"):'',
                "user_id"               :localStorage.getItem("id"),
                "registration_number"   :this.registration_number,
                "mobile_number_rc"      :this.mobile_number_rc,
                "status"                :status,
                "district_id"           :district_id,
                "district_name"         :district_name,
                "block_id"              :block_id,
                "block_name"            :block_name,
                "panchayat_id"          :panchayat_id,
                "panchayat_name"        :panchayat_name,
                "village_id"            :village_id,
                "village_name"          :village_name,
                "vehicle_type"          :type
            }
        
            this.isLoadingModel = true;
            
            if (this.id && this.id != '') 
            {
                //update
                
            }
            else
            {
                //add
                var promise = apis.vehicle_add(details);
                    promise
                        .then((responseapi) => {
                            this.isLoadingModel = false;
                            this.$swal(responseapi.data.message);
                            this.$router.push({ name: "vehiclemaster" });
                                    
                                    
                                
                        })
                        .catch((error) => {
                            this.isLoadingModel = false;
                            this.$swal(error.response.data);
                            this.$router.push({ name: "vehiclemaster" });
            
                        
                        
                        });
            }
    }
  },
};
</script>

<style lang="scss" scoped>
</style>